var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "configuration-workspaces-container" },
    [
      _c("workspaces-list", {
        attrs: {
          workspaces: _vm.allWorkspaces,
          "selected-workspace": _vm.getSelectedWorkspace,
          isLoading: _vm.isLoading
        },
        on: { "set-selected-workspace": _vm.setSelectedWorkspace }
      }),
      _vm._v(" "),
      _c("v-card", { staticClass: "workspace-card-container" }, [
        _c("h3", { staticClass: "workspace-title" }, [_vm._v("Map")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "workspace-container" },
          [
            _c("workspace-map", {
              ref: "workspaceMap",
              attrs: {
                polygon: _vm.getSelectedPolygon,
                workspace: _vm.getSelectedWorkspace,
                "draw-polygon": true,
                "view-all-workspaces": false,
                "is-npv": true
              },
              on: {
                "clear-selected-workspace": _vm.clearSelectedWorkspace,
                "feature-wkt": _vm.polygonGeomatry
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31083882", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31083882","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/views/ConfigurationWorkspaces.vue
// module id = null
// module chunks = 